import {
  FaTachometerAlt,
  FaUserFriends,
  FaCar,
  FaCheck,
  FaBars,
  FaReadme,
  FaFile,
  FaBriefcase,
  FaCity,
} from "react-icons/fa";

export const SidebarLinks = [
  {
    id: 1,
    menuName: "Dashboard",
    menuIcon: <FaTachometerAlt size={15} />,
    path: "/",
  },
  {
    id: 2,
    menuName: "Party Master",
    menuIcon: <FaUserFriends size={17} />,
    path: "/parties",
  },
  {
    id: 3,
    menuName: "City Master",
    menuIcon: <FaCity size={17} />,
    path: "/cities",
  },
  {
    id: 4,
    menuName: "Transporter Master",
    menuIcon: <FaCar size={17} />,
    path: "/transporters",
  },
  {
    id: 5,
    menuName: "Pick List",
    menuIcon: <FaBriefcase size={17} />,
    path: "/pick-lists",
  },
  {
    id: 6,
    menuName: "Checker Panel",
    menuIcon: <FaCheck size={17} />,
    path: "/checker-panel",
  },
  {
    id: 7,
    menuName: "Pending Invoice",
    menuIcon: <FaBars size={17} />,
    path: "/pending-invoices",
  },
  {
    id: 8,
    menuName: "Pre Dispatch Report",
    menuIcon: <FaFile size={17} />,
    path: "/pre-dispatch-report",
  },
  {
    id: 9,
    menuName: "Dispatch Report",
    menuIcon: <FaReadme size={17} />,
    path: "/dispatch-report",
  },
  {
    id: 10,
    menuName: "Dispatch Summary",
    menuIcon: <FaReadme size={17} />,
    path: "/dispatch-summary",
  },
];
